import { render, staticRenderFns } from "./thirdfourth.vue?vue&type=template&id=1236c18e&"
import script from "./thirdfourth.vue?vue&type=script&lang=js&"
export * from "./thirdfourth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1236c18e')) {
      api.createRecord('1236c18e', component.options)
    } else {
      api.reload('1236c18e', component.options)
    }
    module.hot.accept("./thirdfourth.vue?vue&type=template&id=1236c18e&", function () {
      api.rerender('1236c18e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/alf/homeComponents/third/thirdfourth.vue"
export default component.exports